import React, { useState } from 'react';
import { editReply } from '../services/replyService';
import './EditReplyForm.css';

const EditReplyForm = ({ reply, postId, currentUser, onEditComplete, onCancel }) => {
  const [text, setText] = useState(reply.text);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!text.trim()) {
      setError('Reply cannot be empty');
      return;
    }

    if (text.trim().length > 300) {
      setError('Reply is too long. Maximum 300 characters allowed.');
      return;
    }

    if (text.trim() === reply.text.trim()) {
      onCancel(); // No changes made
      return;
    }

    setIsSubmitting(true);
    setError('');

    try {
      await editReply(postId, reply.id, text, currentUser.uid);
      onEditComplete();
    } catch (error) {
      setError('Failed to edit reply: ' + error.message);
      console.error('Error editing reply:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    setText(reply.text); // Reset to original text
    setError('');
    onCancel();
  };

  return (
    <div className="edit-reply-form">
      <form onSubmit={handleSubmit}>
        <div className="edit-reply-form-group">
          <textarea
            value={text}
            onChange={(e) => setText(e.target.value)}
            rows="2"
            disabled={isSubmitting}
            maxLength="300"
            autoFocus
          />
          <div className="edit-reply-character-count">
            {text.length}/300
          </div>
        </div>

        {error && <div className="edit-reply-error-message">{error}</div>}

        <div className="edit-reply-form-actions">
          <button 
            type="submit" 
            className="edit-reply-save-button"
            disabled={isSubmitting || !text.trim()}
          >
            {isSubmitting ? 'Saving...' : 'Save'}
          </button>
          <button 
            type="button" 
            className="edit-reply-cancel-button"
            onClick={handleCancel}
            disabled={isSubmitting}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditReplyForm;